export const DEFAULT_ROW_DISPLAY_COUNT = 10;
export const ROW_DISPLAY_COUNT_OPTIONS = [10, 15, 20];
